import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

export default function StaffRouteGuard({ children }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("staff_google_token") || "";
    const email = localStorage.getItem("staff_email") || "";
    const role = localStorage.getItem("staff_role") || "";

    if (!token || !email || role !== "admin") {
      localStorage.setItem(
        "staff_guard_error",
        "ログインが必要です。スタッフ用Googleアカウントでログインしてください。"
      );
      navigate("/staff", { replace: true, state: { from: location.pathname } });
    }
  }, [navigate, location.pathname]);

  return <>{children}</>;
}
